<div
  class="app"
  [class.nav-open]="sidebarOpen$ | async"
  [class.sidebar-collapsed]="sidebarCollapsed$ | async">
  <dmp-branding-preview-banner></dmp-branding-preview-banner>
  <dmp-topbar></dmp-topbar>

  <div class="body-row">
    <div class="scrim" (click)="closeSidebar()"></div>
    <dmp-sidebar></dmp-sidebar>

    <main class="main">
      <div class="view">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>

  <dmp-status-bar></dmp-status-bar>
</div>
